// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSingleColumn_root__2Cilg","layoutWrapperMain":"LayoutSingleColumn_layoutWrapperMain__3Jx4S"};